var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page__wrap" },
    [
      _c("v-cursor"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page__content" },
        [_c("v-header"), _vm._v(" "), _vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("v-recaptcha", {
        ref: "hiddenRecaptcha",
        attrs: { sitekey: "6LeontQZAAAAAEUQ1Zpog3EYKAqNcXmD55oE4q93" },
        on: { render: _vm.hiddenRecaptchaRender }
      }),
      _vm._v(" "),
      _c("v-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }